import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { 
  FaChartLine, 
  FaUserAlt, 
  FaBullseye, 
  FaFlask, 
  FaVial, 
  FaHospital,
  FaChevronLeft,
  FaChevronRight,
  FaTrophy,
  FaLightbulb,
  FaClipboardList,
  FaUsers,
  FaFileAlt,
  FaCalendarAlt
} from "react-icons/fa";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { currentUser } = useAuth();
  
  const allNavItems = [
    { path: "/", label: "Dashboard", icon: <FaChartLine />, roles: ["superadmin", "admin"] },
    { path: "/patients", label: "Orders", icon: <FaUserAlt />, roles: ["superadmin", "admin"] },
    { path: "/appointments", label: "Appointments", icon: <FaCalendarAlt />, roles: ["superadmin", "admin"] },
    { path: "/patient-management", label: "Patient Management", icon: <FaUsers />, roles: ["superadmin", "admin"] },
    { path: "/health-goals", label: "Health Goals", icon: <FaBullseye />, roles: ["superadmin"] },
    { path: "/test-masters", label: "Biomarker Masters", icon: <FaFlask />, roles: ["superadmin"] },
    { path: "/vital-test-masters", label: "Test Masters", icon: <FaVial />, roles: ["superadmin"] },
    { path: "/category-score-master", label: "Category Score Master", icon: <FaTrophy />, roles: ["superadmin"] },
    { path: "/tactics-master", label: "Tactics Master", icon: <FaLightbulb />, roles: ["superadmin"] },
    { path: "/history-questions", label: "History Questions", icon: <FaClipboardList />, roles: ["superadmin"] },
    { path: "/report-static-texts", label: "Report Static Texts", icon: <FaFileAlt />, roles: ["superadmin"] },
    { path: "/branch-masters", label: "Branch Masters", icon: <FaHospital />, roles: ["superadmin"] },
  ];

  // Filter nav items based on user role
  const navItems = allNavItems.filter(item => {
    const userRole = currentUser?.role || "superadmin";
    return item.roles.includes(userRole);
  });
  
  return (
    <aside 
      className={`bg-gradient-to-b from-gray-800 to-gray-900 text-white ${collapsed ? 'w-20' : 'w-64'} min-h-screen transition-all duration-300 shadow-lg relative`}
    >
      {/* Quick Actions Area */}
      {/* <div className="py-4 px-3 border-b border-gray-700">
        {!collapsed ? (
          <div className="flex space-x-2">
            <NavLink 
              to="/" 
              className={({isActive}) => `flex-1 ${isActive ? 'bg-orange-600' : 'bg-gray-700 hover:bg-gray-600'} text-white text-xs py-2 px-2 rounded-md transition-colors flex items-center justify-center`}
            >
              <FaChartLine className="mr-1" /> Dashboard
            </NavLink>
            <NavLink 
              to="/patients" 
              className={({isActive}) => `flex-1 ${isActive ? 'bg-orange-600' : 'bg-gray-700 hover:bg-gray-600'} text-white text-xs py-2 px-2 rounded-md transition-colors flex items-center justify-center`}
            >
              <FaUserAlt className="mr-1" /> Patients
            </NavLink>
          </div>
        ) : (
          <div className="flex justify-center space-x-2">
            <NavLink 
              to="/" 
              className={({isActive}) => `${isActive ? 'bg-orange-600' : 'bg-gray-700 hover:bg-gray-600'} text-white p-2 rounded-md transition-colors`}
              title="Dashboard"
            >
              <FaChartLine size={16} />
            </NavLink>
            <NavLink 
              to="/patients" 
              className={({isActive}) => `${isActive ? 'bg-orange-600' : 'bg-gray-700 hover:bg-gray-600'} text-white p-2 rounded-md transition-colors`}
              title="Patients"
            >
              <FaUserAlt size={16} />
            </NavLink>
          </div>
        )}
      </div> */}
      
      {/* Navigation */}
      <nav className="py-2 mt-6">
        <ul className="space-y-1 px-2">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `flex items-center px-4 py-2.5 rounded-lg transition-all duration-200 ${collapsed ? 'justify-center' : ''} ${
                    isActive
                      ? "bg-gradient-to-r from-orange-600 to-orange-500 text-white shadow-md"
                      : "text-gray-300 hover:bg-gray-700/50"
                  }`
                }
                title={collapsed ? item.label : ""}
              >
                <span className={`${collapsed ? 'text-lg' : 'text-base mr-3'}`}>{item.icon}</span>
                {!collapsed && <span className="text-sm">{item.label}</span>}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      
      {/* Collapse Toggle Button */}
      <button 
        onClick={() => setCollapsed(!collapsed)}
        className="absolute -right-3 top-6 bg-gray-700 text-gray-300 hover:text-white p-1 rounded-full shadow-md border border-gray-600 transition-colors"
        title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {collapsed ? <FaChevronRight size={12} /> : <FaChevronLeft size={12} />}
      </button>
      
      {/* Footer */}
      <div className={`absolute bottom-0 left-0 right-0 py-3 px-4 border-t border-gray-700/50 ${collapsed ? 'text-center' : ''}`}>
        <div className="flex items-center justify-center">
          <button 
            onClick={() => setCollapsed(!collapsed)}
            className="text-gray-500 hover:text-gray-300 transition-colors text-xs flex items-center"
          >
            {collapsed ? (
              <FaChevronRight size={10} />
            ) : (
              <>
                <FaChevronLeft size={10} className="mr-1" /> Collapse
              </>
            )}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;